<style>
    @import 'index.less';
    @import 'edit.less';
</style>
<template>
    <div class="_companyinfo">
        <Spin v-if="pageLoading" fix size="large"></Spin>
        <div class="head">
            <span class="title">{{type|getTypeName}}单位编辑</span>
        </div>
        <Tabs :animated="false" type="card" v-if="pageAuth===true">
            <template v-for="(item,index) in baseData">
                <TabPane :label="item.title" v-if="baseData.length>0" >
                    <!--首屏 基本信息-->
                    <div v-if="index===0">

                        <Form ref="partoneForm" label-position="top" :inline="true" :model="formData[index]" :rules="rule.park.partOne">
                            <Row>
                                <Col span="9" class="_company_edit_company_name_">
                                    <FormItem prop="companyname" style="width: 100%">
                                        <label slot="label" class="label-title">单位名称<span class="start" style="color: #ed3f14">*</span><span-tip :content="'(单位名称修改 请联系客服 400-161-6251)'"></span-tip></label>
                                        <Input type="text" disabled  v-model="formData[index].companyname"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="4" offset="2">
                                    <FormItem prop="aliases" style="width: 100%">
                                        <label slot="label" class="label-title">别名<span-tip :content="'（多个别名请用逗号或空格隔开）'"></span-tip></label>
                                        <Input type="text" v-model="formData[index].aliases" placeholder="请填写别名"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="3" offset="1" :style="{width:'135px'}">
                                    <FormItem label="LOGO" prop="logo" style="width: 100%">
                                        <label slot="label" class="label-title">LOGO<span-tip :content="'（200px*150px）'"></span-tip></label>
                                        <input type="hidden" v-model="formData[index].logo" style="display: none" />
                                        <Upload accept=".jpg,.png,.jpeg,.gif" :format="['jpg','png','jpeg','gif']" :action="uploadUrl" :headers="uploadHeader" name="file[]" :show-upload-list="false" :on-format-error="checkFormat" :on-success="(response)=>{logoUploadSuccess(response,index)}" :on-error="logoUploadError">
                                            <Button icon="ios-cloud-upload-outline" :style="{width:'100%',padding:'6px 10px',fontWeight:'100'}">点击上传LOGO</Button>
                                        </Upload>
                                    </FormItem>
                                </Col>
                                <Col span="2" :style="{marginLeft:'25px'}">
                                    <div class="logo-border">
                                        <img :src="formData[index].logo" :onerror="'this.src=\''+ require('@/assets/images/default-logo.jpg')+'\'' " />
                                    </div>
                                </Col>
                            </Row>
                            <!--园区-->
                            <div v-if="type==='2'">
                                <Row>
                                    <Col span="9">
                                        <address-select
                                            @refreshData="refreshDirect(index)"
                                            ref="addsel"
                                            :title="'单位地区'"
                                            :input-width="'33.33%'"
                                            :all="true" :level="3"
                                            :default-options="[formData[index].district_1st,formData[index].district_2nd,formData[index].district_3rd]"
                                            :rules="['district_1st','district_2nd','district_3rd']"></address-select>
                                    </Col>
                                    <Col span="4" offset="2" prop="address">
                                        <FormItem label="地址" prop="address" style="width: 100%">
                                            <Input type="text" v-model="formData[index].address" placeholder="请填写地址"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="4" offset="1" prop="xy">
                                    <FormItem label="地图标注" prop="xy" style="width: 100%">
                                        <Input readonly @on-focus="showMap(index)" type="text" v-model="formData[index].xy" placeholder="点击地图进行标注"></Input>
                                    </FormItem>
                                    <baidu-map ref="baiduMap" @selectPoint="xy=>{setXY(xy,index)}" :xy="getXY(formData[index].xy)"></baidu-map>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span="9">
                                        <FormItem label="手机号码" prop="mobile" style="width: 100%">
                                            <label slot="label" class="label-title">手机号码<span class="start">*</span><span-tip :content="'（手机/座机至少填一个）'"></span-tip></label>
                                            <Input type="text"  v-model="formData[index].mobile" placeholder="请填写对外招商手机号" ></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="9" offset="2">
                                        <FormItem class="phone-input-box" label="座机号码" prop="phone" style="width: 100%;white-space: nowrap">
                                            <label slot="label" class="label-title">座机号码<span class="start">*</span><span-tip :content="'（手机/座机至少填一个）'"></span-tip></label>

                                            <input type="text" class="ivu-input"  v-model="formData[index].phone[0]" placeholder="请填写区号" style="width:calc( 33.33333% - 18px );border-top-right-radius: 0;border-bottom-right-radius: 0"/>
                                            <input type="text" class="ivu-input line"  value=" - " disabled />
                                            <input type="text" class="ivu-input"  v-model="formData[index].phone[1]" placeholder="请填写座机号" style="width:calc( 33.33333% - 18px );border-radius: 0"/>
                                            <input type="text" class="ivu-input line"  value=" - " disabled />
                                            <input type="text" class="ivu-input"  v-model="formData[index].phone[2]" placeholder="请填写分机号" style="width:calc( 34.2% - 20px );border-top-left-radius: 0;border-bottom-left-radius: 0"/>
                                            <div style="display: none">
                                                <Input v-model="formData[index].phone[0]"></Input>
                                                <Input v-model="formData[index].phone[1]"></Input>
                                                <Input v-model="formData[index].phone[2]"></Input>
                                            </div>
                                        </FormItem>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span="4">
                                        <FormItem label="行政分类" prop="park_type" style="width: 100%">
                                            <Select v-model="formData[index].park_type" placeholder="请选择行政分类">
                                                <Option :value="'1'" :key="'1'">国家级</Option>
                                                <Option :value="'3'" :key="'3'">地市级</Option>
                                                <Option :value="'2'" :key="'2'">省级</Option>
                                                <Option :value="'4'" :key="'4'">其他</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span="4" offset="1">
                                        <FormItem label="园区类型" prop="park_class" style="width: 100%">
                                            <Select v-model="formData[index].park_class" placeholder="请选择园区类型">
                                                <Option :value="'1'" :key="'1'">开发区</Option>
                                                <Option :value="'2'" :key="'2'">高新区</Option>
                                                <Option :value="'3'" :key="'3'">新城区</Option>
                                                <Option :value="'4'" :key="'4'">总部经济园</Option>
                                                <Option :value="'5'" :key="'5'">创意产业园</Option>
                                                <Option :value="'6'" :key="'6'">工业地产项目</Option>
                                                <Option :value="'7'" :key="'7'">办公园区</Option>
                                                <Option :value="'8'" :key="'8'">生态城</Option>
                                                <Option :value="'9'" :key="'9'">生态城</Option>
                                                <Option :value="'10'" :key="'10'">产业综合体</Option>
                                                <Option :value="'11'" :key="'11'">物流基地</Option>
                                                <Option :value="'12'" :key="'12'">孵化器</Option>
                                                <Option :value="'13'" :key="'13'">众创空间</Option>
                                                <Option :value="'14'" :key="'14'">其他</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>

                                    <Col span="4" offset="2">
                                        <FormItem label="园区官网" prop="park_website" style="width: 100%">
                                            <Input type="text"  v-model="formData[index].park_website" placeholder="请填写园区官网" ></Input>
                                        </FormItem>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span="4">
                                        <FormItem label="土地价格" prop="park_land_price" style="width: 100%">
                                            <Input v-model="formData[index].park_land_price" placeholder="请填写土地价格">
                                                <span slot="append" class="slot-append">万元/亩</span>
                                            </Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="4" offset="1">
                                        <FormItem label="投资强度" prop="park_invest_str" style="width: 100%">
                                            <Input v-model="formData[index].park_invest_str" placeholder="请填写投资强度">
                                            <span slot="append" class="slot-append">万元/亩</span>
                                            </Input>
                                        </FormItem>
                                    </Col>

                                    <Col span="4" offset="2">
                                        <FormItem label="税收要求" prop="park_tax_need" style="width: 100%">
                                            <Input v-model="formData[index].park_tax_need" placeholder="请填写税收要求">
                                            <span slot="append" class="slot-append">万元/亩</span>
                                            </Input>
                                        </FormItem>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span="20">
                                        <FormItem label="基础设施" prop="park_base" style="width: 100%">
                                            <Input type="text"  v-model="formData[index].park_base" placeholder="请填写基础设施" ></Input>
                                        </FormItem>
                                    </Col>
                                </Row>

                                <Row>
                                    <FormItem prop="park_industry" style="width: 100%" v-if="formData[index].park_industry.length===0">
                                        <label slot="label">主导产业</label>
                                    </FormItem>

                                    <template v-for="(vo,k) in formData[index].park_industry" v-if="industryList.length > 0">
                                        <Col span="7" :offset="(k===0 || (k!==1 && k%3===0) )?'0':'1'">
                                            <FormItem prop="park_industry" style="width: 100%;margin-bottom:14px;">
                                                <label slot="label" v-if="k===0">主导产业</label>
                                                <label slot="label" v-else-if="k===1||k===2">&nbsp;</label>
                                                <Select v-model="formData[index].park_industry[k][0]" style="width:40%">
                                                    <Option v-for="idup in industryList" :value="idup.id" :key="idup.id">{{ idup.name }}</Option>
                                                </Select>
                                                <Select v-model="formData[index].park_industry[k][1]" style="width:40%">
                                                    <Option  :value="'0'" :key="'0'">全部</Option>
                                                    <Option v-for="iduc in industrySecondList[formData[index].park_industry[k][0]] ? industrySecondList[formData[index].park_industry[k][0]] : []" :value="iduc.id" :key="iduc.id">{{ iduc.name }}</Option>
                                                </Select>
                                                <div style="display: inline-block;width: 15%;">
                                                    <Button type="default" style="background-color: #FFF;" @click="deletcOneIndustry(k,index)" class="btn-del">删除</Button>
                                                </div>
                                            </FormItem>
                                        </Col>
                                    </template>

                                    <Col span="24">
                                        <select-panel ref="industryPanel" @saveData="data=>{saveIndustryPanel(data,index)}" :default-data="formData[index].park_industry" :panel-data="industryList" :data-type="'3'"></select-panel>
                                        <button type="button" class="add-one-btn" @click="addMainIndustry(index)"><i class="fa fa-plus"></i>添加主导产业</button>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span="20">
                                        <FormItem label="单位介绍" prop="intro" style="width: 100%">
                                            <Input type="textarea" :rows="6"  v-model="formData[index].intro" placeholder="请填写单位介绍" ></Input>
                                        </FormItem>
                                    </Col>
                                </Row>

                                <!-- <Row class="_upload_company_evidence_">
                                    <Col span="20">
                                        <FormItem label="上传证明资料" prop="material_upload_ids" style="width: 100%">
                                            <label slot="label" class="label-title">上传证明资料<span class="start" style="color:#ed3f14">*</span><span-tip :content="'（请下载模板后照提示填写加盖公章扫描后上传）'"></span-tip>  <a target="_blank" :href="companyMaterial" style="color:#2580ef;padding-left: 20px">模板下载</a></label>
                                            <file-upload
                                                    ref="companyEvidence"
                                                    :uploadUrl="uploadUrl"
                                                    :limit-type="['jpg','png','jpeg','doc','docx']"
                                                    :max-size="5120"
                                                    :selected-mode="false"
                                                    @finishUpload="companyEvidenceFinish"></file-upload>
                                            <div style="display:none;" v-if="initPicStatus">
                                                <Input v-model="formData[index].material_upload_ids.join(',')"></Input>
                                            </div>
                                        </FormItem>
                                    </Col>
                                </Row> -->

                                <Row>
                                    <Col span="20">
                                    <FormItem label="图片上传" style="width: 100%">
                                        <label slot="label" class="label-title">上传图片<span-tip :content="'（用于展示单位，图片格式为JPG、PNG，且图片大小不得超过5MB）'"></span-tip></label>
                                        <file-upload
                                        ref="companyPic"
                                        :uploadUrl="uploadUrl"
                                        :limit-type="['jpg','png','jpeg']"
                                        :max-size="5120"
                                        :selected-mode="false"></file-upload>
                                    </FormItem>
                                    </Col>
                                </Row>
                            </div>
                            <FormItem>
                                <Button class="save-part-btn" type="primary" @click="doSave(0)" :loading="loadingStatus">保存</Button>
                            </FormItem>
                        </Form>

                    </div>

                    <!--第二屏 基础情况-->
                    <div v-if="index===1">
                        <Form label-position="top" :inline="true" :model="formData[index]">
                            <Row>
                                <Col span="4">
                                <FormItem label="园区规划面积" prop="park_planning_area" style="width: 100%">
                                    <Input v-model="formData[index].park_planning_area" placeholder="请填写园区规划面积">
                                    <span slot="append" class="slot-append">平方公里</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="园区已建成面积" prop="park_completed_area" style="width: 100%">
                                    <Input v-model="formData[index].park_completed_area" placeholder="请填写园区已建成面积">
                                    <span slot="append" class="slot-append">平方公里</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="2">
                                <FormItem label="园区每年GDP" prop="park_year_gdp" style="width: 100%">
                                    <Input v-model="formData[index].park_year_gdp" placeholder="请填写园区每年GDP">
                                    <span slot="append" class="slot-append">亿元</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="园区每年税收" prop="park_year_tax" style="width: 100%">
                                    <Input v-model="formData[index].park_year_tax" placeholder="请填写园区每年税收">
                                    <span slot="append" class="slot-append">亿元</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="4">
                                <FormItem label="园区每年财政收入" prop="park_year_revenue" style="width: 100%">
                                    <Input v-model="formData[index].park_year_revenue" placeholder="请填写园区每年财政收入">
                                    <span slot="append" class="slot-append">亿元</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="成立时间" prop="park_establish_time" style="width: 100%">
                                    <DatePicker @on-change="setParkEstablishTime" :value="formData[index].park_establish_time" :transfer="true" format="yyyy-MM-dd" type="date" placeholder="请选择成立时间" style="width: 100%;font-size: 12px"></DatePicker>

                                </FormItem>
                                </Col>

                                <Col span="4" offset="2">
                                <FormItem label="园区已入住企业" prop="park_all_settled" style="width: 100%">
                                    <Input v-model="formData[index].park_all_settled" placeholder="请填写园区已入住企业">
                                    <span slot="append" class="slot-append">家</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="园区每年招商新入驻企业约" prop="park_year_settled" style="width: 100%">
                                    <Input v-model="formData[index].park_year_settled" placeholder="请填写园区每年招商新入驻企业约">
                                    <span slot="append" class="slot-append">家</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="园区企业代表" prop="park_behalf_companies" style="width: 100%">
                                    <Input type="text"  v-model="formData[index].park_behalf_companies" placeholder="请填写园区企业代表" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <Button class="save-part-btn" type="primary" @click="doSave(1)" :loading="loadingStatus">保存</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <!--第三屏 园区资源-->
                    <div v-if="index===2">
                        <Form label-position="top" :inline="true" :model="formData[index]">
                            <Row>
                                <Col span="4">
                                <FormItem label="本地人口" prop="park_native_population" style="width: 100%">
                                    <Input v-model="formData[index].park_native_population" placeholder="请填写本地人口">
                                    <span slot="append" class="slot-append">万</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="流动人口" prop="park_floating_population" style="width: 100%">
                                    <Input v-model="formData[index].park_floating_population" placeholder="请填写流动人口">
                                    <span slot="append" class="slot-append">万</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="9" offset="2">
                                <FormItem label="周边职业学院" prop="park_peripheral_college" style="width: 100%">
                                    <Input v-model="formData[index].park_peripheral_college" placeholder="请填写周边职业学院">
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="4">
                                <FormItem label="每年毕业人口" prop="park_year_graduate" style="width: 100%">
                                    <Input v-model="formData[index].park_year_graduate" placeholder="请填写每年毕业人口">
                                    <span slot="append" class="slot-append">万</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="7">
                                <FormItem label="项目审批权限" prop="park_item_approval" style="width: 100%">
                                    <RadioGroup v-model="formData[index].park_item_approval" size="large">
                                        <Radio label="1">是</Radio>
                                        <Radio label="0">否</Radio>
                                    </RadioGroup>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="1">
                                <FormItem label="财政是否独立" prop="park_financial_independence" style="width: 100%">
                                    <RadioGroup v-model="formData[index].park_financial_independence" size="large">
                                        <Radio label="1">是</Radio>
                                        <Radio label="0">否</Radio>
                                    </RadioGroup>
                                </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <Button class="save-part-btn" type="primary" @click="doSave(2)" :loading="loadingStatus">保存</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <!--第四屏 区位交通-->
                    <div v-if="index===3" class="part-three">
                        <Form label-position="top" :inline="true" :model="formData[index]">

                            <Row>
                            <!--终极大循环，看懂的都哭了-->
                                <template v-for="(v,k) in formData[index].park_freight_station_value">
                                    <Col span="6" :offset="(k===0||(k%3===0&&k!==1)) ? '0' : '1'">
                                        <FormItem  style="width: 100%">
                                            <label slot="label" v-if="k===0">货运站</label>
                                            <label slot="label" v-else>&nbsp;</label>
                                            <Input placeholder="请填写货运站" v-model="formData[index].park_freight_station_value[k]">
                                                <Input slot="append" class="input-unit" placeholder="距离km" v-model="formData[index].park_freight_station_unit[k]"></Input>
                                            </Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="1" offset="0" v-if="k > 0">
                                        <FormItem  style="width: 100%">
                                            <label slot="label">&nbsp;</label>
                                            <Button type="default" style="background-color: #fff;margin-left: 10px" @click="partFourDel(1,index,k)">删除</Button>
                                        </FormItem>
                                    </Col>
                                </template>
                            </Row>
                            <Row>
                                <Col span="4">
                                    <button type="button" class="add-one-btn" @click="partFourAdd(1,index)"><i class="fa fa-plus"></i>添加货运站</button>
                                </Col>
                            </Row>

                            <Row>
                                <!--终极大循环，看懂的都哭了-->
                                <template v-for="(v,k) in formData[index].parak_hsr_value">
                                    <Col span="6" :offset="(k===0||(k%3===0&&k!==1)) ? '0' : '1'">
                                    <FormItem  style="width: 100%">
                                        <label slot="label" v-if="k===0">高铁站</label>
                                        <label slot="label" v-else>&nbsp;</label>
                                        <Input placeholder="请填写高铁站" v-model="formData[index].parak_hsr_value[k]">
                                        <Input slot="append" class="input-unit" placeholder="距离km" v-model="formData[index].parak_hsr_unit[k]"></Input>
                                        </Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="1" offset="0" v-if="k > 0">
                                    <FormItem  style="width: 100%">
                                        <label slot="label">&nbsp;</label>
                                        <Button type="default" style="background-color: #fff;margin-left: 10px" @click="partFourDel(2,index,k)">删除</Button>
                                    </FormItem>
                                    </Col>
                                </template>
                            </Row>
                            <Row>
                                <Col span="4">
                                <button type="button" class="add-one-btn" @click="partFourAdd(2,index)"><i class="fa fa-plus"></i>添加高铁站</button>
                                </Col>
                            </Row>

                            <Row>
                                <!--终极大循环，看懂的都哭了-->
                                <template v-for="(v,k) in formData[index].park_port_value">
                                    <Col span="6" :offset="(k===0||(k%3===0&&k!==1)) ? '0' : '1'">
                                    <FormItem  style="width: 100%">
                                        <label slot="label" v-if="k===0">港口</label>
                                        <label slot="label" v-else>&nbsp;</label>
                                        <Input placeholder="请填写港口" v-model="formData[index].park_port_value[k]">
                                        <Input slot="append" class="input-unit" placeholder="距离km" v-model="formData[index].park_port_unit[k]"></Input>
                                        </Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="1" offset="0" v-if="k > 0">
                                    <FormItem  style="width: 100%">
                                        <label slot="label">&nbsp;</label>
                                        <Button type="default" style="background-color: #fff;margin-left: 10px" @click="partFourDel(3,index,k)">删除</Button>
                                    </FormItem>
                                    </Col>
                                </template>
                            </Row>
                            <Row>
                                <Col span="4">
                                <button type="button" class="add-one-btn" @click="partFourAdd(3,index)"><i class="fa fa-plus"></i>添加港口</button>
                                </Col>
                            </Row>

                            <Row>
                                <!--终极大循环，看懂的都哭了-->
                                <template v-for="(v,k) in formData[index].parak_airport_value">
                                    <Col span="6" :offset="(k===0||(k%3===0&&k!==1)) ? '0' : '1'">
                                    <FormItem  style="width: 100%">
                                        <label slot="label" v-if="k===0">机场</label>
                                        <label slot="label" v-else>&nbsp;</label>
                                        <Input placeholder="请填写机场" v-model="formData[index].parak_airport_value[k]">
                                        <Input slot="append" class="input-unit" placeholder="距离km" v-model="formData[index].parak_airport_unit[k]"></Input>
                                        </Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="1" offset="0" v-if="k > 0">
                                    <FormItem  style="width: 100%">
                                        <label slot="label">&nbsp;</label>
                                        <Button type="default" style="background-color: #fff;margin-left: 10px" @click="partFourDel(4,index,k)">删除</Button>
                                    </FormItem>
                                    </Col>
                                </template>
                            </Row>
                            <Row>
                                <Col span="4">
                                <button type="button" class="add-one-btn" @click="partFourAdd(4,index)"><i class="fa fa-plus"></i>添加机场</button>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="公路运输" prop="park_road_transportation" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_road_transportation" placeholder="请填写公路运输" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="铁路运输" prop="intro" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_railway_transportation" placeholder="请填写铁路运输" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="区位介绍" prop="intro" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_location_description" placeholder="请填写区位介绍" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <Button class="save-part-btn" type="primary" @click="doSave(3)" :loading="loadingStatus">保存</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <!--第五屏 招商载体-->
                    <div v-if="index===4">
                        <Form label-position="top" :inline="true" :model="formData[index]">
                            <Row>
                                <Col span="4">
                                <FormItem label="土地存量" prop="park_land_stock" style="width: 100%">
                                    <Input v-model="formData[index].park_land_stock" placeholder="请填写土地存量">
                                    <span slot="append" class="slot-append">亩</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="是否有指标" prop="park_quota_name" style="width: 100%">
                                    <RadioGroup v-model="formData[index].park_quota" size="large">
                                        <Radio label="1">是</Radio>
                                        <Radio label="0">否</Radio>
                                    </RadioGroup>
                                </FormItem>
                                </Col>
                                <Col span="3" offset="2">
                                    <FormItem label="拿证时间" prop="park_land_certificate_time1" style="width: 100%">
                                        <Input class="between-line-left" v-model="formData[index].park_land_certificate_time1">
                                        <span slot="append" class="slot-append"> - </span>
                                        </Input>
                                    </FormItem>
                                </Col>
                                <Col span="3">
                                    <FormItem prop="park_land_certificate_time2" style="width: 100%">
                                        <label slot="label">&nbsp;</label>
                                        <Input  class="between-line-right" v-model="formData[index].park_land_certificate_time2">
                                        <span slot="append" class="slot-append">天</span>
                                        </Input>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="3">
                                    <FormItem label="厂房出租价格区间" prop="park_plant_rent1" style="width: 100%">
                                        <Input class="between-line-left" v-model="formData[index].park_plant_rent1">
                                        <span slot="append" class="slot-append"> - </span>
                                        </Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="3">
                                    <FormItem prop="park_plant_rent2" style="width: 100%">
                                        <label slot="label">&nbsp;</label>
                                        <Input  class="between-line-right" v-model="formData[index].park_plant_rent2">
                                        <span slot="append" class="slot-append">元/㎡·月</span>
                                        </Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="3" offset="5">
                                    <FormItem label="厂房出售价格区间" prop="park_plant_sale1" style="width: 100%">
                                        <Input class="between-line-left" v-model="formData[index].park_plant_sale1">
                                        <span slot="append" class="slot-append"> - </span>
                                        </Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="3">
                                    <FormItem prop="park_plant_sale2" style="width: 100%">
                                        <label slot="label">&nbsp;</label>
                                        <Input  class="between-line-right" v-model="formData[index].park_plant_sale2">
                                        <span slot="append" class="slot-append">元/㎡</span>
                                        </Input>
                                    </FormItem>
                                    </Col>
                            </Row>

                            <Row>
                                <Col span="3">
                                <FormItem label="写字楼出租价格区间" prop="park_office_rent1" style="width: 100%">
                                    <Input class="between-line-left" v-model="formData[index].park_office_rent1">
                                    <span slot="append" class="slot-append"> - </span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="3">
                                <FormItem prop="park_office_rent2" style="width: 100%">
                                    <label slot="label">&nbsp;</label>
                                    <Input  class="between-line-right" v-model="formData[index].park_office_rent2">
                                    <span slot="append" class="slot-append">元/㎡·月</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="3" offset="5">
                                <FormItem label="写字楼出售价格区间" prop="park_office_sale1" style="width: 100%">
                                    <Input class="between-line-left" v-model="formData[index].park_office_sale1">
                                    <span slot="append" class="slot-append"> - </span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="3">
                                <FormItem prop="park_office_sale2" style="width: 100%">
                                    <label slot="label">&nbsp;</label>
                                    <Input  class="between-line-right" v-model="formData[index].park_office_sale2">
                                    <span slot="append" class="slot-append">元/㎡</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <Button class="save-part-btn" type="primary" @click="doSave(4)" :loading="loadingStatus">保存</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <!--第六屏 投资成本-->
                    <div v-if="index===5">
                        <Form label-position="top" :inline="true" :model="formData[index]">
                            <Row>
                                <Col span="4">
                                <FormItem label="地价" prop="park_price_land" style="width: 100%">
                                    <Input v-model="formData[index].park_price_land" placeholder="请填写地价">
                                    <span slot="append" class="slot-append">万元/亩</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="水价" prop="park_water_land" style="width: 100%">
                                    <Input v-model="formData[index].park_water_land" placeholder="请填写水价">
                                    <span slot="append" class="slot-append">元/m³</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="2">
                                <FormItem label="居民用电" prop="park_residential_electricity" style="width: 100%">
                                    <Input v-model="formData[index].park_residential_electricity" placeholder="请填写居民用电">
                                    <span slot="append" class="slot-append">元/度</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="商业用电" prop="park_commercial_electricity" style="width: 100%">
                                    <Input v-model="formData[index].park_commercial_electricity" placeholder="请填写商业用电">
                                    <span slot="append" class="slot-append">元/度</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="4">
                                <FormItem label="大工业用电" prop="park_large_industrial_electricity" style="width: 100%">
                                    <Input v-model="formData[index].park_large_industrial_electricity" placeholder="请填写大工业用电">
                                    <span slot="append" class="slot-append">元/度</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="工业电价（高峰）" prop="park_industrial_electricity_peak" style="width: 100%">
                                    <Input v-model="formData[index].park_industrial_electricity_peak" placeholder="请填写工业电价（高峰）">
                                    <span slot="append" class="slot-append">元/度</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="2">
                                <FormItem label="工业电价（低谷）" prop="park_industrial_electricity_trough" style="width: 100%">
                                    <Input v-model="formData[index].park_industrial_electricity_trough" placeholder="请填写工业电价（低谷）">
                                    <span slot="append" class="slot-append">元/度</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="工业电价（平时）" prop="park_industrial_electricity_usual" style="width: 100%">
                                    <Input v-model="formData[index].park_industrial_electricity_usual" placeholder="请填写工业电价（平时）">
                                    <span slot="append" class="slot-append">元/度</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="4">
                                <FormItem label="天然气" prop="park_natural_gas" style="width: 100%">
                                    <Input v-model="formData[index].park_natural_gas" placeholder="请填写天然气">
                                    <span slot="append" class="slot-append">元/m³</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="污水处理" prop="park_sewage_treatment" style="width: 100%">
                                    <Input v-model="formData[index].park_sewage_treatment" placeholder="请填写污水处理">
                                    <span slot="append" class="slot-append">元/吨</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="2">
                                <FormItem label="蒸汽" prop="park_steam_have" style="width: 100%">
                                    <RadioGroup v-model="formData[index].park_steam_have" size="large">
                                        <Radio label="1">有</Radio>
                                        <Radio label="0">无</Radio>
                                    </RadioGroup>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="1">
                                <FormItem label="蒸汽价格" prop="park_steam" style="width: 100%">
                                    <Input v-model="formData[index].park_steam" placeholder="请填写蒸汽价格">
                                    <span slot="append" class="slot-append">元/吨</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="4">
                                <FormItem label="暖气成本" prop="park_heater" style="width: 100%">
                                    <Input v-model="formData[index].park_heater" placeholder="请填写暖气成本">
                                    <span slot="append" class="slot-append">元/㎡</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="7">
                                <FormItem label="最低工资标准" prop="park_minimum_wage" style="width: 100%">
                                    <Input v-model="formData[index].park_minimum_wage" placeholder="请填写最低工资标准">
                                    <span slot="append" class="slot-append">元/月</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="普通工人" prop="park_ordinary_worker" style="width: 100%">
                                    <Input v-model="formData[index].park_ordinary_worker" placeholder="请填写普通工人">
                                    <span slot="append" class="slot-append">元/月</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="4">
                                <FormItem label="中级管理人员" prop="park_middle_managers" style="width: 100%">
                                    <Input v-model="formData[index].park_middle_managers" placeholder="请填写中级管理人员">
                                    <span slot="append" class="slot-append">元/月</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="高级管理人员" prop="park_senior_management" style="width: 100%">
                                    <Input v-model="formData[index].park_senior_management" placeholder="请填写高级管理人员">
                                    <span slot="append" class="slot-append">元/月</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="2">
                                <FormItem label="房产税" prop="park_property_tax" style="width: 100%">
                                    <Input v-model="formData[index].park_property_tax" placeholder="请填写房产税">
                                    <span slot="append" class="slot-append">元/年</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="土地使用税" prop="park_land_holding_tax" style="width: 100%">
                                    <Input v-model="formData[index].park_land_holding_tax" placeholder="请填写土地使用税">
                                    <span slot="append" class="slot-append">元/㎡·年</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <Button class="save-part-btn" type="primary" @click="doSave(5)" :loading="loadingStatus">保存</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <!--第七屏 配套设施-->
                    <div v-if="index===6">
                        <Form label-position="top" :inline="true" :model="formData[index]">

                            <Row>
                                <Col span="4">
                                <FormItem label="园区周边房价" prop="park_surrounding_house_prices" style="width: 100%">
                                    <Input v-model="formData[index].park_surrounding_house_prices" placeholder="请填写园区周边房价">
                                    <span slot="append" class="slot-append">元/㎡</span>
                                    </Input>
                                </FormItem>
                                </Col>
                                <Col span="4" offset="1">
                                <FormItem label="两居室租金" prop="park_tworoom_rent" style="width: 100%">
                                    <Input v-model="formData[index].park_tworoom_rent" placeholder="请填写两居室租金">
                                    <span slot="append" class="slot-append">元/月</span>
                                    </Input>
                                </FormItem>
                                </Col>

                                <Col span="4" offset="2">
                                <FormItem label="本市住房均价" prop="park_city_house_price" style="width: 100%">
                                    <Input v-model="formData[index].park_city_house_price" placeholder="请填写本市住房均价">
                                    <span slot="append" class="slot-append">元/㎡</span>
                                    </Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="园区生活配套" prop="park_life_support" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_life_support" placeholder="请填写园区生活配套" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="居住环境" prop="park_living_environment" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_living_environment" placeholder="请填写居住环境" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="商业环境" prop="park_business_environment" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_business_environment" placeholder="请填写商业环境" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="超市" prop="park_supermarket" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_supermarket" placeholder="请填写超市" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="百货商场" prop="park_department_store" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_department_store" placeholder="请填写百货商场" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="酒店商务" prop="park_hotels" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_hotels" placeholder="请填写酒店商务" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="休闲娱乐" prop="park_amusement" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_amusement" placeholder="请填写休闲娱乐" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="医疗" prop="park_medical" style="width: 100%">
                                    <Input type="textarea" :rows="4"  v-model="formData[index].park_medical" placeholder="请填写医疗" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span="20">
                                <FormItem label="教育" prop="park_education" style="width: 100%">
                                    <Input type="textarea" :rows="4" v-model="formData[index].park_education" placeholder="请填写教育" ></Input>
                                </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <Button class="save-part-btn" type="primary"  @click="doSave(6)" :loading="loadingStatus">保存</Button>
                            </FormItem>
                        </Form>
                    </div>
                </TabPane>
            </template>
        </Tabs>
        <span style="clear: both"></span>
    </div>
</template>

<script>
    import editValidate from "@/validateRule/company/editCompany";
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import Config from '@/config.js';
    import $api from "@/service/index";
    import utils from "@/utils";
    import spanTip from "@/components/labelTip/labelTip.vue";
    import AddressSelect from "@/components/addressSelect/AddressSelect";
    import baiduMap from "@/components/baiduMap/map";
    import SelectPanel from "@/components/selectPanel/SelectPanel";
    import FileUpload from "@/components/upload/Upload";
    import Cookies from 'js-cookie';

    export default {
        components:{
            spanTip,
            AddressSelect,
            baiduMap,
            SelectPanel,
            FileUpload,
        },
        data(){
            return {
                initPicStatus : false, //初始化证明资料图标是否成功标志位
                loadingStatus : false, //保存按钮loading状态
                pageLoading : true,     //页面加载状态
                rule : editValidate,    //表单雁阵规则
                pageAuth : false,   //编辑单位的权限
                baseData : [],      //单位基本信息
                formData : [],      //表单数据
                companyId : "0",    //单位id
                type : "0",         //单位类型,
                companyMaterial: Config.companyMaterial,   //单位证明资料模板资源url
                uploadUrl :     Config.uploadUrl,    //图片上传地址
                //上传请求header
                uploadHeader: {
                    token: Cookies.get('token'),
                    theOne: Cookies.get('theOne'),
                    source: 'web',
                    uid: Cookies.get('uid')
                },
                industryList : [],  //主导产业一级备选项
                industrySecondList : {}, //主导产业二级备选项
                picList : [],
            }
        },
        filters : {
            //基于单位类型获取类型名
            getTypeName(type){
                return utils.getCompanyTypeName(type);
            }
        },
        created(){
            //补充验证规则
            this.addMoreRule();
            //获取权限
            this.getPageAuth();
            //单位产业分类备选项
            this.getIndustryType();
            //单位基本信息
            this.getCompanyBaseInfo();
        },
        methods : {
            //补充验证规则(手机座机至少填一个)
            addMoreRule(){
                let _self = this;
                this.rule.park.partOne.mobile.push(
                    {validator: (rule, value, callback) => {
                        if(!_self.formData[0].mobile || _self.formData[0].mobile===""){
                                if( _self.formData[0].phone[0]==="" && _self.formData[0].phone[1]==="" && _self.formData[0].phone[2]===""){
                                    callback(new Error("手机和座机至少填写一个"));
                                }
                        }
                        callback();
                    }}
                );
                this.rule.park.partOne.phone.push(
                    {validator: (rule, value, callback) => {
                        if(!_self.formData[0].mobile || _self.formData[0].mobile===""){
                            if( _self.formData[0].phone[0]==="" && _self.formData[0].phone[1]==="" && _self.formData[0].phone[2]===""){
                                callback(new Error("手机和座机至少填写一个"));
                            }
                        }
                        callback();
                    }}
                );

            },
            //获取权限
            getPageAuth(){
                this.pageAuth = utils.judgeAuth([baseAuthEnum.EDIT_COMPANY_INFO],1);
            },
            //获取单位图片列表并初始化单位图片及上传证明资料图
            getCompanyPicList(){
                let _self = this;
                $api.getCompanyPics().then(data=>{
                    _self.picList = data;
                    //初始化图片
                    for(let i = 0 ; i < data.length ; i++){
                            // _self.$refs.companyPic[0].addFilesToFileList(data[i].id,data[i].name,data[i].url,data[i].check);
                            _self.$refs.companyPic[0].addFilesToFileList(data[i].id,data[i].name,data[i].url,false);
                    }
                    // _self.initEpicShow();
                });
            },
            //获取产业分类备选项并做格式调整
            getIndustryType(){
                let _self = this;
                $api.getIndustryKindList().then(data=>{
                    _self.industryList = data;
                    for(let i=0;i<data.length;i++){
                        _self.industrySecondList[data[i].id] = data[i].son ? data[i].son : [];
                    }
                    _self.industrySecondList = Object.assign({}, _self.industrySecondList);
                });
            },
            //添加主导产业按钮点击
            addMainIndustry(index){
                this.$refs.industryPanel[0].show();
            },
            /**
             * 删除主导产业点击按钮
             * @param {int} k 带删除项索引
             * @param {int} index 所属数组外层索引
             */
            deletcOneIndustry(k,index){
                this.formData[index].park_industry.splice(k,1);
            },
            /**
             * 选择主导产业之后点保存的回调
             * @param {array} data 回调携带
             * @param {int} index 所属数组外层索引
             */
            saveIndustryPanel(data,index){
                this.formData[index].park_industry = [].concat(data);
            },
            //调整表单主导产业数据格式
            changePartIndustryTypeData(){
                let data = this.formData[0].park_industry;
                if(data === ""){
                    data = [];
                }else{
                    data = data.toString().split(",");
                    for(let i=0;i<data.length;i++){
                        data[i] = data[i].toString().split("_");
                        for(let k = 0; k< data[i].length;k++){
                            if(data[i][k] === "x"){
                                data[i][k] = "0";
                            }
                        }
                    }
                }
                this.formData[0].park_industry = [].concat(data);
            },
            /**
             * 设置成立时间
             * @param {array} data 回调携带数据
             */
            setParkEstablishTime(data){
                this.formData[1].park_establish_time = data;
            },
            //获取公司基本信息
            getCompanyBaseInfo(){
                let _self = this;
                this.pageLoading = true;
                $api.getCompanyInfo().then(data => {
                    _self.pageLoading = false;
                    _self.baseData = data.data;
                    _self.formData = this.adjustFormData(data);
                    _self.companyId = data.id;
                    _self.type = data.type;

                    //调整座机号
                    _self.changePhone();
                    //调整主导产业数据格式
                    _self.changePartIndustryTypeData();
                    //调整区位交通数据格式
                    _self.changePartFourData();

                    _self.$nextTick(()=>{
                        //获取并初始化单位图片及上传证明资料图
                        _self.getCompanyPicList();
                    });

                });
            },
            //这里调整获取表单数据格式
            adjustFormData(data){
                let arr = [];
                if(data.data && data.data.length >0){
                    for(let i=0;i<data.data.length;i++){
                        arr[i] = {};
                        let list = data.data[i].list;
                        for(let k=0;k<list.length;k++){
                            arr[i][list[k].name]=  list[k].value;
                        }
                    }
                }
                return arr;
            },
            //调整座机号格式
            changePhone(){
                this.formData[0].phone = this.formData[0].phone.split("-");
            },
            // //初始化上传证明资料的图片
            // initEpicShow(){
            //     let list = [].concat(this.formData[0].material_upload_ids);
            //     this.formData[0].material_upload_ids = [];
            //     for(let i = 0 ; i < list.length; i++){
            //         this.$refs.companyEvidence[0].addFilesToFileList(list[i].id,list[i].name,list[i].url);
            //     }
            //     this.initPicStatus = true;
            // },
            /**
             * 地区选择器更新数据
             * @param {int} index 所属外层数组索引
             */
            refreshDirect(index){
                if(this.$refs.addsel){
                    let addr = this.$refs.addsel[0].getSelect();
                    this.formData[index].district_1st = addr[0] ? addr[0] : "";
                    this.formData[index].district_2nd = addr[1] ? addr[1] : "";
                    this.formData[index].district_3rd = addr[2] ? addr[2] : "";
                }
            },
            /**
             * logo上传成功回调
             * @param {object} response 上传回调数据
             * @param {int} index 所属外层数组索引
             */
            logoUploadSuccess(response, index){
                let pic = response.data[0].domain+response.data[0].logo;
                this.formData[index] = Object.assign(this.formData[index],{"logo":pic});
            },
            //上传logo失败回调
            logoUploadError(){
                utils.notice('上传失败','error');
            },
            // /**
            //  * 上传证明资料回调
            //  * @param {array} data 上传回调数据
            //  */
            // companyEvidenceFinish(data){
            //     this.formData[0].material_upload_ids = data ? data : [];
            // },
            /**
             * 将经纬度解成数组格式
             * @param {array} xy 经纬度数组
             * @returns {string}
             */
            getXY(xy){
                if(typeof xy === "string"){
                    xy = xy.split(",");
                }
                //默认天安门
                return xy;
            },
            /**
             * 获取地图标注所选数据
             * @param {array} xy 经纬度数组
             * @param {int} index 所属外层数组索引
             */
            setXY(xy,index){
                this.formData[index].x = xy[0];
                this.formData[index].y = xy[1];
                this.formData[index].xy = xy.join(",");
                this.formData = [].concat(this.formData);
            },
            //弹出地图标注的方法
            showMap(index){
                this.$refs.baiduMap[0].show();
            },
            //整理part4区位交通的数据格式
            changePartFourData(){
                if(!this.formData[3]){
                    return false;
                }
                if(this.formData[3].park_freight_station_id || this.formData[3].park_freight_station_id===""){
                    this.formData[3].park_freight_station_id = this.formData[3].park_freight_station_id.split(",");
                }
                if(this.formData[3].park_freight_station_value || this.formData[3].park_freight_station_value === ""){
                    this.formData[3].park_freight_station_value = this.formData[3].park_freight_station_value.split(",");
                }
                if(this.formData[3].park_freight_station_unit || this.formData[3].park_freight_station_unit === ""){
                    this.formData[3].park_freight_station_unit = this.formData[3].park_freight_station_unit.split(",");
                }

                if(this.formData[3].parak_hsr_id || this.formData[3].parak_hsr_id === ""){
                    this.formData[3].parak_hsr_id = this.formData[3].parak_hsr_id.split(",");
                }
                if(this.formData[3].parak_hsr_value || this.formData[3].parak_hsr_value === ""){
                    this.formData[3].parak_hsr_value = this.formData[3].parak_hsr_value.split(",");
                }
                if(this.formData[3].parak_hsr_unit || this.formData[3].parak_hsr_unit === ""){
                    this.formData[3].parak_hsr_unit = this.formData[3].parak_hsr_unit.split(",");
                }

                if(this.formData[3].park_port_id || this.formData[3].park_port_id === ""){
                    this.formData[3].park_port_id = this.formData[3].park_port_id.split(",");
                }
                if(this.formData[3].park_port_value || this.formData[3].park_port_value === ""){
                    this.formData[3].park_port_value = this.formData[3].park_port_value.split(",");
                }
                if(this.formData[3].park_port_unit || this.formData[3].park_port_unit === ""){
                    this.formData[3].park_port_unit = this.formData[3].park_port_unit.split(",");
                }

                if(this.formData[3].parak_airport_id || this.formData[3].parak_airport_id === ""){
                    this.formData[3].parak_airport_id = this.formData[3].parak_airport_id.split(",");
                }
                if(this.formData[3].parak_airport_value || this.formData[3].parak_airport_value === ""){
                    this.formData[3].parak_airport_value = this.formData[3].parak_airport_value.split(",");
                }
                if(this.formData[3].parak_airport_unit || this.formData[3].parak_airport_unit === ""){
                    this.formData[3].parak_airport_unit = this.formData[3].parak_airport_unit.split(",");
                }
            },
            /**
             * part4区位交通删除按钮的事件
             * @param {int} type 分类
             * @param {int} index 所属外层数组索引
             * @param {int} k 待删除项的索引
             */
            partFourDel(type,index,k){
                switch (type){
                    case 1:
                        //货运站
                        this.formData[index].park_freight_station_id.splice(k,1);
                        this.formData[index].park_freight_station_unit.splice(k,1);
                        this.formData[index].park_freight_station_value.splice(k,1);
                        break;
                    case 2:
                        //高铁站
                        this.formData[index].parak_hsr_id.splice(k,1);
                        this.formData[index].parak_hsr_unit.splice(k,1);
                        this.formData[index].parak_hsr_value.splice(k,1);
                        break;
                    case 3:
                        //港口
                        this.formData[index].park_port_id.splice(k,1);
                        this.formData[index].park_port_unit.splice(k,1);
                        this.formData[index].park_port_value.splice(k,1);
                        break;
                    case 4:
                        //机场
                        this.formData[index].parak_airport_id.splice(k,1);
                        this.formData[index].parak_airport_unit.splice(k,1);
                        this.formData[index].parak_airport_value.splice(k,1);
                        break;
                    default:
                        break
                }
            },
            /**
             * part4区位交通添加按钮的事件
             * @param {int} type 分类
             * @param {int} index 所属外层数组索引
             */
            partFourAdd(type,index){
                switch (type){
                    case 1:
                        //货运站
                        this.formData[index].park_freight_station_id.push("");
                        this.formData[index].park_freight_station_unit.push("");
                        this.formData[index].park_freight_station_value.push("");
                        break;
                    case 2:
                        //高铁站
                        this.formData[index].parak_hsr_id.push("");
                        this.formData[index].parak_hsr_unit.push("");
                        this.formData[index].parak_hsr_value.push("");
                        break;
                    case 3:
                        //港口
                        this.formData[index].park_port_id.push("");
                        this.formData[index].park_port_unit.push("");
                        this.formData[index].park_port_value.push("");
                        break;
                    case 4:
                        //机场
                        this.formData[index].parak_airport_id.push("");
                        this.formData[index].parak_airport_unit.push("");
                        this.formData[index].parak_airport_value.push("");
                        break;
                    default:
                        break
                }
            },
            /**
             * 保存按钮点击事件
             * @param {int} part 待保存的内容所属第几tab
             * @param {string} type 保存类型[暂时废弃]
             */
            doSave(part=1,type="2"){
                switch(part){
                    case 0:
                        //基本信息
                        this.partZeroSave();
                        break;
                    case 1:
                        //基础情况
                        this.partOneSave();
                        break;
                    case 2:
                        //园区资源
                        this.partTwoSave();
                        break;
                    case 3:
                        //区位交通
                        this.partThreeSave();
                        break;
                    case 4:
                        //招商载体
                        this.partFourSave();
                        break;
                    case 5:
                        //骰子成本
                        this.partFiveSave();
                        break;
                    case 6:
                        //配套设置
                        this.partSixSave();
                        break;
                    default:
                        break;
                }
            },
            /**
             * 公共ajaxPut提交
             * @param {object} data 待提交的数据
             * @param {string} update_type 1:基本信息修改 2：其他信息修改
             * @returns {boolean}
             */
            doPutData(data,update_type = "1"){
                if(!data){
                    return false;
                }
                data.update_type = update_type;
                let companyId = this.companyId;
                let _self = this;
                // console.log(data);
                if(this.loadingStatus === true){
                    return false;
                }
                this.loadingStatus = true;
                $api.setCompanyBaseInfo(companyId,data).then(data=>{
                    _self.loadingStatus = false;
                    if(data.code === "200"){
                        utils.message({title:'保存成功'},"success");
                        _self.$router.push({
                            name : "companyinfo",
                        })
                    }else{
                        utils.message({title:data.msg},"error");
                    }

                });
            },
            //part6配套设施保存按钮
            partSixSave(){
                if(!this.formData[6]){
                    return false;
                }
                let item = this.formData[6];
                let postData = {
                    "park_surrounding_house_prices" : item.park_surrounding_house_prices ? item.park_surrounding_house_prices : "",
                    "park_tworoom_rent"             : item.park_tworoom_rent ? item.park_tworoom_rent : "",
                    "park_city_house_price"         : item.park_city_house_price ? item.park_city_house_price : "",
                    "park_life_support"             : item.park_life_support ? item.park_life_support : "",
                    "park_living_environment"       : item.park_living_environment ? item.park_living_environment : "",
                    "park_business_environment"     : item.park_business_environment ? item.park_business_environment : "",
                    "park_supermarket"              : item.park_supermarket ? item.park_supermarket : "",
                    "park_department_store"         : item.park_department_store ? item.park_department_store : "",
                    "park_hotels"                   : item.park_hotels ? item.park_hotels : "",
                    "park_amusement"                : item.park_amusement ? item.park_amusement : "",
                    "park_medical"                  : item.park_medical ? item.park_medical : "",
                    "park_education"                : item.park_education ? item.park_education : "",
                };
                //axios
                this.doPutData(postData,"2");
            },
            //part5投资成本保存按钮
            partFiveSave(){
                if(!this.formData[5]){
                    return false;
                }
                let item = this.formData[5];
                let postData = {
                    "park_price_land"                   : item.park_price_land ? item.park_price_land : "",
                    "park_water_land"                   : item.park_water_land ? item.park_water_land : "",
                    "park_residential_electricity"      : item.park_residential_electricity ? item.park_residential_electricity : "",
                    "park_commercial_electricity"       : item.park_commercial_electricity ? item.park_commercial_electricity : "",
                    "park_large_industrial_electricity" : item.park_large_industrial_electricity ? item.park_large_industrial_electricity : "",
                    "park_industrial_electricity_peak"  : item.park_industrial_electricity_peak ? item.park_industrial_electricity_peak : "",
                    "park_industrial_electricity_trough": item.park_industrial_electricity_trough ? item.park_industrial_electricity_trough : "",
                    "park_industrial_electricity_usual" : item.park_industrial_electricity_usual ? item.park_industrial_electricity_usual : "",
                    "park_natural_gas"                  : item.park_natural_gas ? item.park_natural_gas : "",
                    "park_sewage_treatment"             : item.park_sewage_treatment ? item.park_sewage_treatment : "",
                    "park_steam_have"                   : item.park_steam_have ? item.park_steam_have : "",
                    "park_steam"                        : item.park_steam ? item.park_steam : "",
                    "park_heater"                       : item.park_heater ? item.park_heater : "",
                    "park_minimum_wage"                 : item.park_minimum_wage ? item.park_minimum_wage : "",
                    "park_ordinary_worker"              : item.park_ordinary_worker ? item.park_ordinary_worker : "",
                    "park_middle_managers"              : item.park_middle_managers ? item.park_middle_managers : "",
                    "park_senior_management"            : item.park_senior_management ? item.park_senior_management : "",
                    "park_property_tax"                 : item.park_property_tax ? item.park_property_tax : "",
                    "park_land_holding_tax"             : item.park_land_holding_tax ? item.park_land_holding_tax : "",
                };
                //axios
                this.doPutData(postData,"2");
            },
            //part4招商载体保存按钮
            partFourSave(){
                if(!this.formData[4]){
                    return false;
                }
                let item = this.formData[4];
                let postData = {
                    "park_land_stock"               : item.park_land_stock ? item.park_land_stock : "",
                    "park_quota"                    : item.park_quota ? item.park_quota : "",
                    "park_land_certificate_time1"   : item.park_land_certificate_time1 ? item.park_land_certificate_time1 : "",
                    "park_land_certificate_time2"   : item.park_land_certificate_time2 ? item.park_land_certificate_time2 : "",
                    "park_plant_rent1"              : item.park_plant_rent1 ? item.park_plant_rent1 : "",
                    "park_plant_rent2"              : item.park_plant_rent2 ? item.park_plant_rent2 : "",
                    "park_plant_sale1"              : item.park_plant_sale1 ? item.park_plant_sale1 : "",
                    "park_plant_sale2"              : item.park_plant_sale2 ? item.park_plant_sale2 : "",
                    "park_office_rent1"             : item.park_office_rent1 ? item.park_office_rent1 : "",
                    "park_office_rent2"             : item.park_office_rent2 ? item.park_office_rent2 : "",
                    "park_office_sale1"             : item.park_office_sale1 ? item.park_office_sale1 : "",
                    "park_office_sale2"             : item.park_office_sale2 ? item.park_office_sale2 : "",
                };
                //axios
                this.doPutData(postData,"2");

            },
            //part3区位交通保存按钮
            partThreeSave(){
                if(!this.formData[3]){
                    return false;
                }
                let item = this.formData[3];
                let postData = {
                    "park_freight_station" : [],
                    "parak_hsr" : [],
                    "park_port" : [],
                    "parak_airport" : [],
                    "park_location_description" : item.park_location_description,
                    "park_road_transportation" : item.park_road_transportation,
                    "park_railway_transportation" : item.park_railway_transportation,
                };

                for(let i = 0 ; i < item.park_freight_station_id.length ; i++){
                    if(!(item.park_freight_station_value[i] === "" && item.park_freight_station_unit[i] === "")){
                        postData.park_freight_station.push({
                            "id"   :   item.park_freight_station_id[i],
                            "value":   item.park_freight_station_value[i],
                            "unit" :   item.park_freight_station_unit[i],
                        });
                    }
                }

                for(let i = 0 ; i < item.parak_hsr_id.length ; i++){
                    if(!(item.parak_hsr_value[i] === "" && item.parak_hsr_unit[i] === "")){
                        postData.parak_hsr.push({
                            "id"   :   item.parak_hsr_id[i],
                            "value" :   item.parak_hsr_value[i],
                            "unit":   item.parak_hsr_unit[i],
                        });
                    }
                }

                for(let i = 0 ; i < item.park_port_id.length ; i++){
                    if(!(item.park_port_value[i] === "" && item.park_port_unit[i] === "")){
                        postData.park_port.push({
                            "id"   :   item.park_port_id[i],
                            "value":   item.park_port_value[i],
                            "unit" :   item.park_port_unit[i],
                        });
                    }
                }

                for(let i = 0 ; i < item.park_port_id.length ; i++){
                    if(!(item.parak_airport_value[i] === "" && item.parak_airport_unit[i]==="")){
                        postData.parak_airport.push({
                            "id"   :   item.parak_airport_id[i],
                            "value":   item.parak_airport_value[i],
                            "unit" :   item.parak_airport_unit[i],
                        });
                    }
                }
                //axios
                this.doPutData(postData,"3");
            },
            //part2园区资源保存按钮
            partTwoSave(){
                if(!this.formData[2]){
                    return false;
                }
                let item = this.formData[2];
                let postData = {
                    "park_native_population"        : item.park_native_population ? item.park_native_population : "",
                    "park_floating_population"      : item.park_floating_population ? item.park_floating_population : "",
                    "park_peripheral_college"       : item.park_peripheral_college ? item.park_peripheral_college : "",
                    "park_year_graduate"            : item.park_year_graduate ? item.park_year_graduate : "",
                    "park_item_approval"            : item.park_item_approval ? item.park_item_approval : "",
                    "park_financial_independence"   : item.park_financial_independence ? item.park_financial_independence : "",
                };
                //axios
                this.doPutData(postData,"2");
            },
            //part1基础情况保存按钮
            partOneSave(){
                if(!this.formData[1]){
                    return false;
                }
                let item = this.formData[1];
                let postData = {
                    "park_planning_area"    : item.park_planning_area ? item.park_planning_area : "",
                    "park_completed_area"   : item.park_completed_area ? item.park_completed_area : "",
                    "park_year_gdp"         : item.park_year_gdp ? item.park_year_gdp : "",
                    "park_year_tax"         : item.park_year_tax ? item.park_year_tax : "",
                    "park_year_revenue"     : item.park_year_revenue ? item.park_year_revenue : "",
                    "park_establish_time"   : item.park_establish_time ? item.park_establish_time : "",
                    "park_all_settled"      : item.park_all_settled ? item.park_all_settled : "",
                    "park_year_settled"     : item.park_year_settled ? item.park_year_settled : "",
                    "park_behalf_companies" : item.park_behalf_companies ? item.park_behalf_companies : "",
                };
                //axios
                this.doPutData(postData,"2");
            },
            //part0基本信息保存按钮
            partZeroSave(){
                //整理基本信息数据格式
                let res = true;
                this.$refs.partoneForm[0].validate((valid) => {
                    if (!valid) {
                        res = false;
                    }
                });
                if(!res){
                    utils.notice("您还有信息未填写或未验证通过","error");
                    return false;
                }
                let postData = this.fixBaseInfoData();
                this.doPutData(postData,"1");
            },
            //基础信息提交前整理数据格式
            fixBaseInfoData(){
                let data = this.formData[0];
                let res = {
                    "companyname": data.companyname ? data.companyname : "",
                    "logo" : data.logo ? utils.removeDomain(data.logo) : "",
                    "aliases" : data.aliases ? data.aliases : "",
                    "x" : data.x ? data.x.toString() : (data.xy ? data.xy.split(",")[0].toString() : ""),
                    "y" : data.y ? data.y.toString() : (data.xy ? data.xy.split(",")[1].toString() : ""),
                    "district_1st" : data.district_1st ? data.district_1st : "0",
                    "district_2nd" : data.district_2nd ? data.district_2nd : "0",
                    "district_3rd" : data.district_3rd ? data.district_3rd : "0",
                    "address" : data.address ? data.address : "",
                    "mobile" : data.mobile ? data.mobile : "",
                    "phone" : data.phone.join("-") ? data.phone.join("-") : "",
                    "park_type" : data.park_type ? data.park_type : "",
                    "park_class" : data.park_class ? data.park_class : "",
                    "park_land_price" : data.park_land_price ? data.park_land_price : "",
                    "park_invest_str" : data.park_invest_str ? data.park_invest_str : "",
                    "park_tax_need" : data.park_tax_need ? data.park_tax_need : "",
                    "park_website" : data.park_website ? data.park_website : "",
                    "park_base" : data.park_base ? data.park_base : "",
                    "industry" : [],        //主导产业
                    "intro" : data.intro ? data.intro : "",
                    // "material_upload_ids" : data.material_upload_ids ? data.material_upload_ids.join(",") : "", //证明材料
                    "pic_upload_ids" : "",  //图片上传
                    "check_pic_id" : "",    //选中图片
                };

                //整理主导产业
                for(let i = 0;i<data.park_industry.length;i++){
                    res.industry.push({
                        "1st" : data.park_industry[i][0] ? data.park_industry[i][0] : "0",
                        "2nd" : data.park_industry[i][1] ? data.park_industry[i][1] : "0"
                    });
                };


                //整理图片上传
                let pic = this.$refs.companyPic[0].getFileList();
                let picList = [];
                let checkPic = [];
                for(let i = 0;i<pic.length;i++){
                    picList.push(pic[i].id.toString());
                    if(pic[i].checked === true){
                        checkPic.push(pic[i].id.toString());
                    }
                }

                let checkPicStr = checkPic[0] ? checkPic[0] : (picList[0] ? picList[0] : "");
                let picListStr = picList.join(",");

                res.pic_upload_ids = picListStr;
                res.check_pic_id = checkPicStr;

                return  res;
            },
            /**
             * 检查上传logo格式提示
             */
            checkFormat(){
                utils.notice("文件格式错误,仅支持jpg,png,jpeg,gif格式的文件");
            }
        },

    }
</script>
<style lang="less" scoped>
    @import "./edit";
</style>


// WEBPACK FOOTER //
// src/pages/company/baseinfo/Edit.vue